import { TemplateTypes } from 'api/services/templates/types';

export default [
  {
    value: TemplateTypes.POST,
    label: 'Пост',
  },
  {
    value: TemplateTypes.PAGE,
    label: 'Страница',
  },
];
